import { graphql } from "@opensea/graphql"
import { useSetBlockchainActionErrorsFragment } from "../../hooks/useSetBlockchainActionErrors.fragment"
import { CancelOrderFlowStatus_orderFragment } from "./components/CancelOrderFlowStatus/CancelOrderFlowStatus.fragment"
import { CancelOrderTableFragment } from "./components/CancelOrderTable/CancelOrderTable.fragment"
import { GaslessCancelOrderStatusFragment } from "./components/GaslessCancelOrderStatus/GaslessCancelOrderStatus.fragment"

export const CancelOrderFlowContentFragment = graphql(
  `
    fragment CancelOrderFlowContent on BlockchainActionResponse {
      actions {
        __typename
        ... on CancelOrdersAction {
          orders {
            id
            side
            ...CancelOrderFlowStatus_order
            ...CancelOrderTable
          }
        }
        ... on GaslessCancelOrdersAction {
          ...GaslessCancelOrderStatus
          orders {
            id
            side
            ...CancelOrderFlowStatus_order
            ...CancelOrderTable
          }
        }
      }
      errors {
        ...useSetBlockchainActionErrors
      }
    }
  `,
  [
    CancelOrderFlowStatus_orderFragment,
    GaslessCancelOrderStatusFragment,
    useSetBlockchainActionErrorsFragment,
    CancelOrderTableFragment,
  ],
)
